import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "RBS",
  name: "RBS",
  slug: "rbs",
  ...colors,
  pictures: [{ id: "rbs_train_v1.png" }, { id: "rbs_bus_v1.png" }],
};
export default config;
